<template>
  <div id="info-card" :class="[this.$lang === 'ar' ? 'regular-ar' : 'regular-en']">
    <div :class="[this.$lang === 'ar' ? 'flex-row-reverse' : '', 'info-card']">
      <div :class="[this.$lang === 'ar' ? 'right-dir' : 'left-dir', 'text d-flex']">
        <img class="icon" src="../../assets/icons/info.svg">
        <div class="px-2">
          <div :class="[this.$lang === 'ar' ? 'bold-italic-ar' : 'bold-italic-en', 'titles']">
            <img class="info-icon" src="../../assets/icons/info.svg">
            <span v-if="type !== 'animated'">{{boxTitle}}</span>
            <div class="position-relative"  v-if="type === 'animated'">
              <span style="opacity: 0">{{boxTitle}}</span>
              <span :class="isOpen ? 'opacity' : 'no-opacity'" :style="this.$lang === 'ar' ? { right: 0 } : {left: 0}" class="position-absolute txt open">{{$t('products.addInfo.title')}}</span>
              <span :class="!isOpen ? 'opacity' : 'no-opacity'" :style="this.$lang === 'ar' ? { right: 0 } : {left: 0}" class="position-absolute txt close">{{$t('paymentAndRefill.boxTitle')}}</span>
            </div>
          </div>
          <div :class="[this.$lang === 'ar' ? 'regular-ar' : 'regular-en', 'type position-relative']">
            <span v-if="type !== 'animated'">{{mtnLine}}</span>
            <div class="position-relative"  v-if="type === 'animated'">
              <span style="opacity: 0">{{paymentAndRefill}}</span>
              <span :class="isOpen ? 'opacity' : 'no-opacity'" :style="this.$lang === 'ar' ? { right: 0 } : {left: 0}" class="position-absolute txt open">{{paymentAndRefill}}</span>
              <span :class="!isOpen ? 'opacity' : 'no-opacity'" :style="this.$lang === 'ar' ? { right: 0 } : {left: 0}" class="position-absolute txt close">{{paymentAndRefill}}</span>
            </div>
          </div>
        </div>
      </div>
      <div @click="handleAnimation" class="mobile-arrow-container"><img class="mobile-arrow" src="../../assets/icons/down-white-arrow.svg"></div>
      <div @click="handleAnimation" :class="[this.$lang === 'ar' ? 'flex-row-reverse' : '','button']">
        <div :class="[this.$lang === 'ar' ? 'bold-italic-ar' : 'bold-italic-en', 'btn-title']">{{btn}}</div>
        <div :class="[this.$lang === 'ar' ? 'px-3' : 'px-3', 'arrow-container']"><img src="../../assets/icons/white-arrow.svg"/></div>
      </div>
    </div>
    <div class="wrapper">
      <div v-if="fail || !show" class="inner overflow-hidden">
        <div v-if="!show" style="height: 300px; display: flex; align-items: center; justify-content: center; flex-direction: column">
          <loader />
        </div>
        <error v-if="fail" />
      </div>
      <ul :class="[this.$lang === 'ar' ? 'right-dir' : 'left-dir','inner']">
        <li class="list mb-5" v-for="(item, i) in items" :key="i" v-html="item"></li>
      </ul>
    </div>
  </div>
</template>
<script>
import $ from 'jquery'
import Loader from '../LoaderBtn/Loader'
import Error from '../errorHandle/Error'
export default {
  components: { Error, Loader },
  props: {
    data: Array,
    load: Boolean,
    error: Boolean,
    fetchedBefore: Boolean,
    type: String,
    title: String,
    section: String
  },
  watch: {
    data (val) {
      this.items = [...val]
    },
    load (val) {
      if (val) {
        this.show = false
        this.fail = false
      } else {
        this.show = true
      }
    },
    error (val) {
      if (val) {
        this.fail = true
        this.show = true
      }
    }
  },
  data () {
    return {
      mtnLine: this.$store.state.productsInnerTab === 0 ? this.$t('products.addInfo.extraPre') : this.$t('products.addInfo.extraPost'),
      paymentAndRefill: this.$t('paymentAndRefill.additionalInfoClose'),
      isOpen: false,
      items: [],
      btn: this.$store.state.window > 500 ? this.$t('products.addInfo.btn') : this.$lang === 'ar' ? 'المزيد' : 'More',
      show: false,
      fail: false,
      width: this.$store.state.window,
      boxTitle: this.$t('products.addInfo.title')
    }
  },
  created () {
    if (this.fetchedBefore) {
      this.show = true
      this.fail = false
      this.items = [...this.data]
    }
    if (this.section === 'international' || this.section === 'SMS') {
      this.mtnLine = this.title
    }
    this.$watch(() => {
      return this.$store.state.productsInnerTab
    }, (val) => {
      this.info = this.$store.state.productsInnerTab === 0 ? this.$t('products.addInfo.extraPre') : this.$t('products.addInfo.extraPost')
    })
    this.$watch(() => {
      return this.$store.state.window
    }, (val) => {
      this.width = val
      this.btn = val > 500 ? this.$t('products.addInfo.btn') : this.$lang === 'ar' ? 'المزيد' : 'More'
    })
  },
  methods: {
    handleAnimation () {
      if (!this.isOpen) {
        $('#info-card .wrapper').addClass('is-open')
        $('#info-card .arrow-container').addClass('rotate')
        $('#info-card .mobile-arrow-container').addClass('rotate')
        this.btn = this.$lang === 'ar' ? 'إخفاء' : this.width > 500 ? 'Show Less' : 'Less'
        this.isOpen = true
        if (this.type === 'animated') {
          this.paymentAndRefill = this.$t('paymentAndRefill.additionalInfoOpen')
          this.boxTitle = this.$t('paymentAndRefill.boxTitle')
        }
      } else {
        $('#info-card .wrapper').removeClass('is-open')
        $('#info-card .arrow-container').removeClass('rotate')
        $('#info-card .mobile-arrow-container').removeClass('rotate')
        this.btn = this.$lang === 'ar' ? 'المزيد' : this.width > 500 ? 'Show More' : 'More'
        this.isOpen = false
        if (this.type === 'animated') {
          this.paymentAndRefill = this.$t('paymentAndRefill.additionalInfoClose')
          this.boxTitle = this.$t('products.addInfo.title')
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.opacity{
  opacity: 0;
}
.no-opacity{
  opacity: 1;
  transition: opacity .3s ease-in-out;
}
.mobile-arrow-container{
  display: none;
}
.info-icon{
  display: none;
}
.rotate {
  transform: rotate(180deg);
}
#info-card{
  width: 92%;
  background: #FFCB05;
  margin: 0 auto;
  border-radius: 40px;
  border: 3px solid rgba(255,255,255,.7);
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 40px;
  text-align: initial;
  box-shadow: 15px 15px 40px rgba(0,0,0,.1);
}
.info-card{
  margin-top: 16px;
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px;
}
.button{
  width: 200px;
  height: 55px;
  color: #fff;
  border: 3px solid #fff;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  .arrow-container{
    transition: all .3s ease-in-out;
  }
}
.titles{
  font-size: 22px;
  color: #fff;
  text-align: initial;
  transition: opacity .2s ease-in-out;
}
.wrapper{
  display: grid;
  grid-template-rows: 0fr;
  transition: all .3s ease-in-out;
}
ul {
  padding: 0 75px;
  color: #FFFFFF;
  overflow: hidden;
  font-size: 13px;
}
li{
  width: max-content;
}
li.list{
  width: fit-content !important;
  overflow-wrap: anywhere;
}
.is-open{
  grid-template-rows: 1fr;
}
@media (max-width: 680px) {
  .button{
    width: 160px !important;
  }
  .info-card {
    padding: 0 20px !important;
  }
  .titles{
    font-size: 20px;
  }
  .type{
    font-size: 14px;
  }
  ul{
    padding: 0 60px !important;
  }
  li{
    word-wrap: break-word;
    width: 100%;
  }
}
@media (max-width: 680px) {
  .titles{
    text-decoration: underline;
    font-size: 19px;
    display: flex;
  }
  .info-card{
    min-height: 90px;
    /*padding-top: 16px !important;*/
  }
  .button,
  .type{
    display: none;
  }
  .mobile-arrow-container{
    display: block;
    color: #fff;
    cursor: pointer;
    transition-duration: .3s;
    margin: 5px 10px 0px 0;
  }
  .mobile-arrow{
    height: 15px;
    width: 15px
  }
  .icon{
    display: none
  }
  .info-icon{
    display: initial;
    height: 30px;
    width: 30px;
    margin: 0 6px;
    margin-bottom: 5px;
  }
}
</style>
<style lang="scss">
#info-card {
  .dot-spinner__dot::before {
    background-color: #F2F2F2 !important;
  }
}
</style>
